const ErrorCodes = {
  INITIALIZATION_PROBLEM: "INITIALIZATION_PROBLEM",
  INVALID_PARAMETERS: "INVALID_PARAMETERS",
  TURNSTILE_API_COMPATIBILITY: "TURNSTILE_API_COMPATIBILITY",
  INVALID_SITEKEY: "INVALID_SITEKEY",
  UNKNOWN_DOMAIN: "UNKNOWN_DOMAIN",
  INVALID_ACTION: "INVALID_ACTION",
  INVALID_CDATA: "INVALID_CDATA",
  UNSUPPORTED_BROWSER: "UNSUPPORTED_BROWSER",
  INCONSISTENT_USER_AGENT: "INCONSISTENT_USER_AGENT",
  CHALLENGE_TIMED_OUT: "CHALLENGE_TIMED_OUT",
  INTERNAL_ERRORS_CLOUDFLARE: "INTERNAL_ERRORS_CLOUDFLARE",
  INVALID_CACHING: "INVALID_CACHING",
  TIME_PROBLEM: "TIME_PROBLEM",
  GENERIC_CLIENT_EXECUTION_ERROR: "GENERIC_CLIENT_EXECUTION_ERROR",
  CHALLENGE_EXECUTION_FAILURE: "CHALLENGE_EXECUTION_FAILURE",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  TIMEOUT_ERROR: "TIMEOUT_ERROR",
  EXPIRED_ERROR: "EXPIRED_ERROR",
};

export function getTurnStileErrorType(errorCode: string) {
  if (/^100\d{2}$/.test(errorCode)) return ErrorCodes.INITIALIZATION_PROBLEM;
  if (/^10[2346]\d{2}$/.test(errorCode)) return ErrorCodes.INVALID_PARAMETERS;
  if (/^105\d{2}$/.test(errorCode)) return ErrorCodes.TURNSTILE_API_COMPATIBILITY;
  if (["110100", "110110"].includes(errorCode)) return ErrorCodes.INVALID_SITEKEY;
  if (errorCode === "110200") return ErrorCodes.UNKNOWN_DOMAIN;
  if (errorCode === "110420") return ErrorCodes.INVALID_ACTION;
  if (errorCode === "110430") return ErrorCodes.INVALID_CDATA;
  if (errorCode === "110500") return ErrorCodes.UNSUPPORTED_BROWSER;
  if (errorCode === "110510") return ErrorCodes.INCONSISTENT_USER_AGENT;
  if (/^1106[02]\d$/.test(errorCode)) return ErrorCodes.CHALLENGE_TIMED_OUT;
  if (/^120\d{3}$/.test(errorCode)) return ErrorCodes.INTERNAL_ERRORS_CLOUDFLARE;
  if (errorCode === "200010") return ErrorCodes.INVALID_CACHING;
  if (errorCode === "200100") return ErrorCodes.TIME_PROBLEM;
  if (/^300\d{3}$/.test(errorCode)) return ErrorCodes.GENERIC_CLIENT_EXECUTION_ERROR;
  if (/^600\d{3}$/.test(errorCode)) return ErrorCodes.CHALLENGE_EXECUTION_FAILURE;
  if (errorCode === "timeout") return ErrorCodes.TIMEOUT_ERROR;
  if (errorCode === "expired") return ErrorCodes.EXPIRED_ERROR;
  return ErrorCodes.UNKNOWN_ERROR;
}

// Mock funkce pro testování - vrací všechny možné error kódy
export function getMockTurnstileErrorTypes(): string[] {
  return [
    ErrorCodes.INITIALIZATION_PROBLEM,
    ErrorCodes.INVALID_PARAMETERS,
    ErrorCodes.TURNSTILE_API_COMPATIBILITY,
    ErrorCodes.INVALID_SITEKEY,
    ErrorCodes.UNKNOWN_DOMAIN,
    ErrorCodes.INVALID_ACTION,
    ErrorCodes.INVALID_CDATA,
    ErrorCodes.UNSUPPORTED_BROWSER,
    ErrorCodes.INCONSISTENT_USER_AGENT,
    ErrorCodes.CHALLENGE_TIMED_OUT,
    ErrorCodes.INTERNAL_ERRORS_CLOUDFLARE,
    ErrorCodes.INVALID_CACHING,
    ErrorCodes.TIME_PROBLEM,
    ErrorCodes.GENERIC_CLIENT_EXECUTION_ERROR,
    ErrorCodes.CHALLENGE_EXECUTION_FAILURE,
    ErrorCodes.UNKNOWN_ERROR,
    ErrorCodes.TIMEOUT_ERROR,
    ErrorCodes.EXPIRED_ERROR,
  ];
}
